<template>
  <div>
    <el-empty :description="msg"></el-empty>
  </div>
</template>
<script>
export default {
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.msg = this.$route.query.errMsg || ''
    }
  }
}
</script>
